module.exports = "<div data-component=\"rescue-result\" class=\"step\" *ngIf=\"active\">\n\t<app-warning [message]=\"rescueData.message\" [type]=\"rescueData.success ? 'success' : 'error'\"></app-warning>\n\t<app-list-confirmation [list]=\"rescueData.resumeList\"></app-list-confirmation>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue-result/rescue-result.component.html
// module id = ../../../../../src/app/master/investments/rescue/rescue-result/rescue-result.component.html
// module chunks = main